import { InternalLogicError } from '@/errors/InternalLogicError';
import { SearchTreeNode, TemplatePlaceholderWithFilterContext } from '@/types';
import { walkTreeAndRemoveEphemeralIdsInPlace } from '@/util';
import { updatePlaceholdersInSearchTreeInPlace } from './placeholderTree';

export function createSearchTemplateJson(
  searchTree: SearchTreeNode | undefined,
  placeholdersData: Record<string, TemplatePlaceholderWithFilterContext>
) {
  if (!searchTree) {
    throw new InternalLogicError(
      'Unexpected state: searchTree is undefined in call to createSearchTemplateJson()'
    );
  }
  const searchTreeWithPlaceholdersInjected = structuredClone(searchTree);
  updatePlaceholdersInSearchTreeInPlace(searchTreeWithPlaceholdersInjected, placeholdersData);

  walkTreeAndRemoveEphemeralIdsInPlace(searchTreeWithPlaceholdersInjected);

  const searchTemplateJson = JSON.stringify(searchTreeWithPlaceholdersInjected);

  return searchTemplateJson;
}
